import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
export default function getCompanyName() {
    return getUserConfiguration().SessionSettings.CompanyName;
}
//# sourceMappingURL=getCompanyName.js.map